import * as React from 'react';
import * as styles from './ServicePositionError.css';

const pointerIcon = require('./assets/pointer.png');

interface IServicePositionErrorProps {
  message: React.ReactNode;
}

export const ServicePositionError = ({ message }: IServicePositionErrorProps) => {
  return (
    <div className={styles['wrapper']}>
      <img src={pointerIcon} width={24} height={24} className={styles['pointer-icon']} />
      {message}
    </div>
  );
};
